// @flow
import * as React from 'react';
import { Row, Col, Button, Form, FormGroup, Alert } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { CSSTransitionGroup } from 'react-transition-group';
import { validateRequired, validateEmail } from '../../helpers';
import Input from '../../components/Input';

type State = {
  isArchiving: boolean,
  isSaving: boolean
};

type Props = {
  handleSubmit: (v: Object) => void,
  currentOrganisation: Object,
  messageType: ?string,
  isSaving: boolean,
  message: string
};

class UserInviteForm extends React.Component<Props, State> {
  timeoutId: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      isArchiving: false,
      isSaving: false
    };
    this.timeoutId = undefined;
  }

  render() {
    const { handleSubmit, currentOrganisation = {} } = this.props;
    return (
      <div>
        <Row />
        <p>Invite a new or existing user to {currentOrganisation.name}.</p>
        <Form onSubmit={handleSubmit}>
          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="text"
                  label="User's Name"
                  placeholder="Name"
                  name="name"
                  validate={validateRequired}
                />
              </Col>
            </FormGroup>
          </Row>

          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="text"
                  label="User's Email Address"
                  placeholder="Email Address"
                  name="email"
                  validate={[validateRequired, validateEmail]}
                />
              </Col>
            </FormGroup>
          </Row>

          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="checkbox"
                  label="Admin User?"
                  name="isAdmin"
                />
              </Col>
            </FormGroup>
          </Row>

          <Row>
            <FormGroup>
              <Col sm={12}>
                <Button
                  bsStyle="primary"
                  type="submit"
                  className="relative-padding"
                  disabled={this.props.isSaving}
                >
                  {this.props.isSaving ? 'Sending...' : 'Send Invite'}
                </Button>
              </Col>
            </FormGroup>
          </Row>
          <br />

          <CSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={300}
            transitionLeaveTimeout={300}
          >
            {this.props.message && (
              <div>
                <Alert bsStyle={this.props.messageType}>
                  {this.props.message}
                </Alert>
                <br />
              </div>
            )}
          </CSSTransitionGroup>
        </Form>
      </div>
    );
  }
}

// Decorate the form component
UserInviteForm = reduxForm({
  form: 'userInviteForm'
})(UserInviteForm);

export default UserInviteForm;



// WEBPACK FOOTER //
// ./src/containers/users/UserInviteForm.js